import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BannerService } from './../../../shared/services/banner.service';
import { environment } from './../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['../../../../styles.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

  baseUrl = environment.BRAND_LOGOS_URL;

  acushnetLogo = this.baseUrl + "acushnet-logo-black.png";
  titleistLogo = this.baseUrl + "titleist-logo-black.png";
  footjoyLogo = this.baseUrl + "footjoy-logo-black.png";

  constructor(public service: BannerService) {}

  ngOnInit() {
  }

}
